export const EXSBPRICETYPE_CREATE_RESET = 'EXSBPRICETYPE_CREATE_RESET'
export const EXSBPRICETYPE_CREATE_SET_CREATED = 'EXSBPRICETYPE_CREATE_SET_CREATED'
export const EXSBPRICETYPE_CREATE_SET_ERROR = 'EXSBPRICETYPE_CREATE_SET_ERROR'
export const EXSBPRICETYPE_CREATE_SET_VIOLATIONS = 'EXSBPRICETYPE_CREATE_SET_VIOLATIONS'
export const EXSBPRICETYPE_CREATE_TOGGLE_LOADING = 'EXSBPRICETYPE_CREATE_TOGGLE_LOADING'
